export const warehouseRoutes = [
  {
    path: '/warehouse/warehouse-information',
    component: () => import('@/views/modules/warehouse/warehouse-information/warehouse-information'),
    meta: { name: '仓库资料', keepAlive: true, permission: 'warehouse:view' ,modal:'仓库'}
  },
  {
    path: '/warehouse/product-inventory',
    component: () => import('@/views/modules/warehouse/product-inventory/product-inventory'),
    meta: { name: '产品库存', keepAlive: true, permission: 'productInventory:view' ,modal:'仓库'}
  },
  {
    path: '/warehouse/fba-inventory',
    component: () => import('@/views/modules/warehouse/fba-inventory/fba-inventory'),
    meta: { name: 'FBA库存', keepAlive: true, permission: 'fbaInventory:view' ,modal:'仓库'}
  },
  {
    path: '/warehouse/warehouse-inventory',
    component: () => import('@/views/modules/warehouse/warehouse-inventory/warehouse-inventory'),
    meta: { name: '仓库库存', keepAlive: true, permission: 'warehouseInventory:view',modal:'仓库' }
  },
  {
    path: '/warehouse/inventory-configuration',
    component: () => import('@/views/modules/warehouse/inventory-configuration/inventory-configuration'),
    meta: { name: '库存指标配置', keepAlive: true ,modal:'仓库'}
  },
  {
    path: '/warehouse/inbound-order',
    component: () => import('@/views/modules/warehouse/inbound-order/inbound-order'),
    meta: { name: '采购入库单', keepAlive: true, permission: 'purchaseInbound:view' ,modal:'仓库'}
  },
  {
    path: '/warehouse/assembly-order',
    component: () => import('@/views/modules/warehouse/assembly-order/assembly-order'),
    meta: { name: '装配单', keepAlive: true, permission: 'assemble:view' ,modal:'仓库'}
  },
  {
    path: '/warehouse/transfer-order',
    component: () => import('@/views/modules/warehouse/transfer-order/transfer-order'),
    meta: { name: '调拨单', keepAlive: true, permission: 'transfer:view' ,modal:'仓库'}
  },
  {
    path: '/warehouse/inbound-outbound',
    component: () => import('@/views/modules/warehouse/inbound-outbound/inbound-outbound'),
    meta: { name: '出入库记录', keepAlive: true, permission: 'inbound:view' ,modal:'仓库'}
  },
  {
    path: '/warehouse/inventory-check',
    component: () => import('@/views/modules/warehouse/inventory/inventory'),
    meta: { name: '盘点单', keepAlive: true, permission: 'storageCheck:view' ,modal:'仓库'}
  },
  {
    path: '/warehouse/cost-supplement',
    component: () => import('@/views/modules/warehouse/cost-supplement/cost-supplement.vue'),
    meta: { name: '成本补录', keepAlive: true, permission: 'costSupplement:view' ,modal:'仓库'}
  },
];
